var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "对账备注",
        visible: _vm.visible,
        width: "500px",
        "close-on-click-modal": false,
        "destroy-on-close": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "formRef",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            "label-width": "100px",
            size: "small",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "对账单号：", "label-width": "100px" } },
            [_c("span", [_vm._v(_vm._s(_vm.form.statementNo || "-"))])]
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "对账备注：", "label-width": "100px" } },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 4,
                  placeholder: "请输入对账备注",
                  maxlength: "500",
                  "show-word-limit": "",
                },
                model: {
                  value: _vm.form.reconciliationRemark,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "reconciliationRemark", $$v)
                  },
                  expression: "form.reconciliationRemark",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("取消")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.submitLoading },
              on: { click: _vm.handleSubmit },
            },
            [_vm._v("保存")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }